import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Sound = (props: IconProps) => (
  <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24Z" />
    <path
      d="M16.3908 14.4398V8.78936C16.3908 8.11868 16.2006 7.55865 15.7421 7.21528C15.2915 6.86879 14.6886 6.82565 14.0516 6.99988C14.0516 6.99988 14.0516 6.99988 14.0515 6.99989L11.1624 7.78965C11.1622 7.7897 11.1621 7.78975 11.1619 7.78979C10.3281 8.01474 9.7904 8.70197 9.7904 9.57442V13.475C9.5469 13.3728 9.27944 13.3147 8.99532 13.3147C7.8401 13.3147 6.9002 14.2535 6.9002 15.4048C6.9002 16.5606 7.83956 17.5 8.99532 17.5C10.1455 17.5 11.0905 16.5611 11.0905 15.4048V11.5961L15.0958 10.4567V12.511C14.8513 12.4076 14.5824 12.3496 14.2957 12.3496C13.146 12.3496 12.2006 13.2879 12.2006 14.4398C12.2006 15.5961 13.1455 16.5349 14.2957 16.5349C15.4515 16.5349 16.3908 15.5955 16.3908 14.4398Z"
      fill="white"
      stroke="black"
      strokeWidth="0.6"
    />
  </Icon>
);
